import { render, staticRenderFns } from "./AssignDataPermissions.vue?vue&type=template&id=bdd2e08a&scoped=true"
import script from "./AssignDataPermissions.vue?vue&type=script&lang=js"
export * from "./AssignDataPermissions.vue?vue&type=script&lang=js"
import style0 from "./AssignDataPermissions.vue?vue&type=style&index=0&id=bdd2e08a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd2e08a",
  null
  
)

export default component.exports